import request from "@/utils/request";
import qs from "qs";
// 查询结算资料
export function xcChannelPayInfo(channelId) {
  return request({
    url: "api/xcChannelPayInfo/" + channelId,
    method: "get",
  });
}
// 新增、修改结算资料
export function updateXcChannelPayInfo(data) {
  return request({
    url: "/api/xcChannelPayInfo",
    method: "post",
    data,
  });
}
// 删除结算资料
export function delXcChannelPayInfo(id) {
  return request({
    url: "api/xcChannelPayInfo/" + id,
    method: "delete",
  });
}
// 上传身份证获取ocr识别
export function uploadIdImg(data) {
  return request({
    url: "api/uploadIdImg",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  });
}
// 通过结算账户id获取信息
export function findXcChannelPayInfoById(id) {
  return request({
    url: "api/findXcChannelPayInfoById/" + id,
    method: "Get",
  });
}



// WEBPACK FOOTER //
// ./src/api/accountCenter.js